<template>
  <div class="howitworks-page">
    <div class="img-text center">
      <div class="contain">
        <div class="text">
          <h2>How It Works.</h2>
          <p>Get surveys out to people under 10 minutes. All you have to do is create a form, add some questions and send it to all your users.</p>
        </div>
        <div class="vid-holder">
          <img
            :src="config.HOW_IT_WORKS_DESKTOP_IMAGE"
          />
          <video
            :src="config.HOW_IT_WORKS_DESKTOP_VIDEO"
            autoplay
            loop
            muted
          ></video>
        </div>
        <div class="btns center">
          <button @click="$router.push({path: '/register'})" class="btn">Get Started</button>
        </div>
      </div>
    </div>
    <div class="img-text center white">
      <div class="contain">
        <div class="text">
          <h2>Taking the Survey.</h2>
          <p>From the user's view it's even simpler. They get an email answer your questions and then get the results immediatly.</p>
        </div>
        <div class="vid-holder phone">
          <img
            :src="config.HOW_IT_WORKS_MOBILE_IMAGE"
          />
          <div class="vid">
            <video
              :src="config.HOW_IT_WORKS_MOBILE_VIDEO"
              autoplay
              loop
              muted
            ></video>
          </div>
        </div>
        <div class="btns center">
          <button @click="$router.push({path: '/register'})" class="btn">Get Started</button>
        </div>
      </div>
    </div>

    <div class="facts center">
      <div class="contain">
        <h2>Survyio, keeping everyone safe.</h2>
        <button @click="goToSurvyio('/features')" class="btn reverse">COVIDPAD FEATURES</button>
      </div>
    </div>

    <foot></foot>
  </div>
</template>

<script>
import firebase from "firebase";
import Footer from "@/components/Footer";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "howitworks",
  components: {
    foot: Footer
  },
  data() {
    return {};
  },
  mounted() {},
  async created() {
    await this.getAffiliates();
  },
  updated() {},
  methods: {}
};
</script>

<style scoped lang='scss'>
.howitworks-page .capture .contain {
  padding-top: 150px;
}

.white {
  background-color: white;
}
</style>
